import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
    appId: process.env.REACT_APP_FIREBASE_APP_ID as string,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Global interceptor to transparently impersonate the user across the app (mocking auth.currentUser)
const proto = Object.getPrototypeOf(auth);
const originalCurrentUserDescriptor = Object.getOwnPropertyDescriptor(proto, 'currentUser');

let overriddenUser: any = null;

Object.defineProperty(auth, 'currentUser', {
    get() {
        const realUser = overriddenUser || (originalCurrentUserDescriptor ? originalCurrentUserDescriptor.get?.call(auth) : null);
        if (!realUser) return null;

        try {
            const imp = sessionStorage.getItem('impersonatedUser');
            if (imp) {
                const pso = JSON.parse(imp);
                return new Proxy(realUser, {
                    get(target, prop, receiver) {
                        if (prop === 'uid') {
                            return pso.authUid || pso.id;
                        }
                        if (prop === 'email') {
                            return pso.email || '';
                        }
                        if (prop === 'displayName') {
                            return pso.name || '';
                        }
                        const value = Reflect.get(target, prop, receiver);
                        if (typeof value === 'function') {
                            return value.bind(target);
                        }
                        return value;
                    }
                });
            }
        } catch (e) {
            console.error('Error reading impersonatedUser:', e);
        }
        return realUser;
    },
    set(val) {
        if (originalCurrentUserDescriptor && originalCurrentUserDescriptor.set) {
            originalCurrentUserDescriptor.set.call(auth, val);
        } else {
            overriddenUser = val;
        }
    },
    configurable: true,
});




